<!-- Start Reset Password Area -->
<div class="reset-password-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="reset-password-content">
                <div class="row m-0">
                    <div class="col-lg-5 p-0">
                        <div class="image">
                            <i class="bx bx-at image-forgot"></i>
                        </div>
                    </div>

                    <div class="col-lg-7 p-0">
                        <div class="reset-password-form">
                            <h2>Restablecer su contraseña</h2>

                            <form>
                                <div class="form-group">
                                    <input type="password" class="form-control" name="name" placeholder="Introduzca una nueva contraseña"
                                    [(ngModel)]="passwordNew">
                                    <span class="label-title"><i class='bx bx-lock'></i></span>
                                </div>

                                <div class="form-group">
                                    <input type="password" class="form-control" name="email" placeholder="Confirma tu nueva contraseña"
                                    [(ngModel)]="passwordConfirm">
                                    <span class="label-title"><i class='bx bx-lock-alt'></i></span>
                                </div>

                                <button class="btn reset-password-btn" (click)="submitReset()" [disabled]="!token || !passwordNew || !passwordConfirm">
                                    Restablecer mi contraseña
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Reset Password Area -->